module.exports = "/_next/static/images/PersonalizationStrategies@2x-286f9b8b6eb4cf90b6ee3c157189e2b1.png";